import { useModelService } from 'services/model/model.service';
import { customKpi, InfoDrawerKpiEntry, measureCustomKpi, measureKpi } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { toFeesAndCostsValueMeasure } from 'components/profitability/profitabilityMeasures';

function useEntityInfoContentKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [
    netSlsGmvVal,
    cm1Val,
    cm2Val,
    netSlsFeeVal,
    itemSlsOmvVal,
    itemSlsGmvVal,
    itemSlsMkdVal,
    netSlsCogVal,
    netSlsMkpFeeVal,
    slsPayFeeVal,
    slsShpCostVal,
    slsHdlCostVal,
    retShpCostVal,
    retHdlCostVal,
    netSlsLogCostVal,
  ] = getMeasures([
    'netSlsGmvValExtExpOD',
    'cm1ValExtExpOD',
    'cm2ValExtExpOD',
    'netSlsFeeValExtExpOD',
    'itemSlsOmvValExtOD',
    'itemSlsGmvValExtOD',
    'itemSlsMkdValExtOD',
    'netSlsCogValExtExpOD',
    'netSlsMkpFeeValExtExpOD',
    'slsPayFeeValOD',
    'slsShpCstValOD',
    'slsHdlCstValOD',
    'retShpCstValExtExpOD',
    'retHdlCstValExtExpOD',
    'netSlsLogCostValExtExpOD',
  ]);

  const feesAndCostsVal = toFeesAndCostsValueMeasure(netSlsFeeVal);

  return [
    measureKpi(netSlsGmvVal),
    measureCustomKpi('cm1ValExtExpOD', cm1Val, 'model.metric.cm1ValLong'),
    customKpi('netSlsFeeValExt_netSlsLogCostValExt', {
      titleId: 'profitability.info.netSlsFeeValExt_netSlsLogCostValExt.title',
      descriptionId: 'profitability.info.netSlsFeeValExt_netSlsLogCostValExt.description',
      measure: feesAndCostsVal,
    }),
    measureCustomKpi('cm2ValExtExpOD', cm2Val, 'model.metric.cm2ValLong'),
    measureCustomKpi('itemSlsOmvValExtOD', itemSlsOmvVal, 'model.metric.itemSlsOmvValExt'),
    measureCustomKpi('itemSlsGmvValExtOD', itemSlsGmvVal, 'model.metric.itemSlsGmvValExt'),
    measureCustomKpi('itemSlsMkdValExtOD', itemSlsMkdVal, 'model.metric.itemSlsMkdValExt'),
    measureKpi(netSlsCogVal),
    measureKpi(netSlsMkpFeeVal),
    measureKpi(slsPayFeeVal),
    measureKpi(netSlsFeeVal),
    customKpi('slsShpCostValExt', {
      titleId: 'profitability.info.slsShpCostValExt.title',
      descriptionId: 'profitability.info.slsShpCostValExt.description',
      measure: slsShpCostVal,
    }),
    customKpi('slsHdlCostValExt', {
      titleId: 'profitability.info.slsHdlCostValExt.title',
      descriptionId: 'profitability.info.slsHdlCostValExt.description',
      measure: slsHdlCostVal,
    }),
    measureKpi(retShpCostVal),
    measureKpi(retHdlCostVal),
    measureKpi(netSlsLogCostVal),
  ];
}

export function ProfitabilityEntityInfoContent() {
  const kpis = useEntityInfoContentKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="profitability.info.whyUseful.entity.description"
      showOrderBasedNote
    />
  );
}
